module.exports = __webpack_public_path__ + "img/IMG_6948.0339eabf.webp";